import * as types from './mutation-types'

export default {
    [types.ADD_RESTAURANT] (state, data) {
        state.restaurantsLoaded = true
        state.restaurants.push(data)
    },

    [types.ADD_RESTAURANTS] (state, data) {
        state.restaurantsLoaded = true
        state.restaurants = data
    },

    [types.RESTAURANT_MEALS]: function (state, {data, restaurant_id}){
        state.restaurantsMeals[restaurant_id] = data
    },

    [types.LOAD_RESTAURANT]: (state, data) => {
        let restaurantExist = state.restaurants.find(x => x.id === data.id)
        if(restaurantExist){
            state.restaurants = state.restaurants.map((x) => {
                if(x.id === data.id){
                    return data
                }

                return x
            })
        }else{
            state.restaurants.push(data)
        }
    }
}


